import React from 'react';

const headerStyle = {
    border: '1px solid #e5e7eb',
    padding: '10px 14px',
    textAlign: 'center',
    backgroundColor: '#f9fafb',
    fontWeight: 600,
    fontSize: '13px',
    color: '#374151',
};

const cellStyle = {
    border: '1px solid #e5e7eb',
    padding: '10px 14px',
    textAlign: 'center',
    fontSize: '13px',
    color: '#1f2937',
};

const labelCellStyle = {
    ...cellStyle,
    textAlign: 'left',
    fontWeight: 500,
};

const preAdviseHighlightStyle = {
    ...cellStyle,
    backgroundColor: '#fef9c3',
};

const tableStyle = {
    border: '1px solid #e5e7eb',
    borderCollapse: 'collapse',
    width: '100%',
};

const totalRowStyle = {
    backgroundColor: '#e5e7eb',
    fontWeight: 600,
};

const AirlineRow = ({ airline }) => (
    <tr>
        <td style={{ ...cellStyle, textAlign: 'center' }}>{airline.rank}</td>
        <td style={labelCellStyle}>{airline.airline}</td>
        <td style={cellStyle}>{airline.totalPreAdvise}</td>
        <td style={cellStyle}>{airline.totalNonAdvise}</td>
        <td style={cellStyle}>{airline.totalAsap}</td>
        <td style={preAdviseHighlightStyle}>{airline.preAdvisePct}%</td>
        <td style={cellStyle}>{airline.nonAdvisePct}%</td>
        <td style={cellStyle}>{airline.total}</td>
        <td style={cellStyle}>{airline.totalPct}%</td>
    </tr>
);

const AirlinePerformancePreadvisedTable = ({ airlines = [], totals }) => {
    if (!airlines?.length && !totals) {
        return <p style={{ fontSize: '14px', color: '#6b7280' }}>No airline data available.</p>;
    }

    return (
        <div style={{ marginBottom: '24px' }}>
            <table style={tableStyle}>
                <thead>
                    <tr>
                        <th style={headerStyle} colSpan={9}>Pre-Advised Rank</th>
                    </tr>
                    <tr>
                        <th style={headerStyle}>Rank</th>
                        <th style={{ ...headerStyle, textAlign: 'left' }}>Airline</th>
                        <th style={headerStyle}>Total Pre-Advise</th>
                        <th style={headerStyle}>Total Non-Advise</th>
                        <th style={headerStyle}>Total Asap</th>
                        <th style={headerStyle}>Pre-Advise %</th>
                        <th style={headerStyle}>Non-Advise %</th>
                        <th style={headerStyle}>Total</th>
                        <th style={headerStyle}>Total %</th>
                    </tr>
                </thead>
                <tbody>
                    {airlines.map((airline) => (
                        <AirlineRow key={airline.airlineCode} airline={airline} />
                    ))}
                    {totals && (
                        <tr style={totalRowStyle}>
                            <td style={cellStyle} />
                            <td style={labelCellStyle}>Total</td>
                            <td style={cellStyle}>{totals.totalPreAdvise}</td>
                            <td style={cellStyle}>{totals.totalNonAdvise}</td>
                            <td style={cellStyle}>{totals.totalAsap}</td>
                            <td style={cellStyle}>{totals.preAdvisePct}%</td>
                            <td style={cellStyle}>{totals.nonAdvisePct}%</td>
                            <td style={cellStyle}>{totals.total}</td>
                            <td style={cellStyle}>{totals.totalPct}%</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default AirlinePerformancePreadvisedTable;
